// extracted by mini-css-extract-plugin
module.exports = {"root":"MainFooter_root__1Nowl"};